import { useEffect } from 'react';
import { milliseconds } from 'date-fns';
import { identify, setUserProperty } from 'utils/tracking';
import { useAuth, useClientSWR } from 'context/AuthContext/AuthContext';

function useTrackIdentity() {
  const { email } = useAuth();
  const { data: platform } = useClientSWR('platform/name', {
    dedupingInterval: milliseconds({ minutes: 15 }),
  });

  useEffect(() => {
    if (email) {
      identify(email);
    }
  }, [email]);

  useEffect(() => {
    if (platform?.name) {
      setUserProperty({ 'Platform Name': platform.name });
    }
  }, [platform]);
}

export default useTrackIdentity;
